import styles from "./InputField.module.scss";

const Select = ({
  register,
  validation,
  name,
  errors,
  label,
  placeholder,
  isStatic,
  options = [],
  watch,
  isSetdefalut = false,
  defalut = {},
  required = false,
}) => {
  const selectedText = options.find((opt) => {
    return String(opt.value) === String(watch(name));
  });
  return (
    <div className={styles.field}>
      <label className={styles.field__label}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>
      <select
        name={name}
        {...register(name, validation)}
        className={`form-select  ${errors[name] ? "is-invalid" : ""} ${
          styles.field__select
        } ${isStatic ? "d-none" : ""}`}
      >
        {isSetdefalut && (
          <option value={defalut.value} key={defalut.value}>
            {defalut.text}
          </option>
        )}
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.text}
          </option>
        ))}
      </select>
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
      {isStatic && (
        <div className={`${styles.field__select}`}>{selectedText?.text}</div>
      )}
    </div>
  );
};
export default Select;
